import React from 'react';
import { Loader2, Sparkles, ScanLine } from 'lucide-react';

interface OrderInputProps {
  orderText: string;
  onOrderTextChange: (text: string) => void;
  onParse: () => void;
  onClear: () => void;
  loading: boolean;
  error: string | null;
}

export const OrderInput: React.FC<OrderInputProps> = ({
  orderText,
  onOrderTextChange,
  onParse,
  onClear,
  loading,
  error
}) => {
  return (
    <section className="light flex flex-col bg-white rounded-2xl shadow-xl border border-gray-200/70 overflow-hidden h-full text-gray-900">
      {/* Header */}
      <div className="px-6 sm:px-8 py-4 sm:py-6 border-b border-gray-100 bg-gray-50/70">
        <h2 className="text-lg sm:text-xl font-semibold text-gray-900 flex items-center gap-2">
          <ScanLine className="w-5 h-5 text-indigo-600" />
          Type or paste
        </h2>
        <p className="mt-1 text-sm text-gray-600 hidden sm:block">
          Copy-paste the full message here
        </p>
      </div>

      {/* Content */}
      <div className="flex-1 px-2 sm:px-8 py-4 sm:py-6 flex flex-col min-h-0">
        <textarea
          className="flex-1 min-h-[400px] sm:min-h-[400px] p-4 sm:p-5 border-2 border-gray-200 rounded-xl sm:rounded-2xl font-mono text-base text-gray-900 leading-relaxed resize-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-shadow shadow-inner bg-gray-50"
          placeholder={`Examples:
• Tomatoes 80 lb
• Cucumbers – 60 lb
• Lemons ½ cs
• 3 Beets
• 10 ps manzanas 🍎

... paste full message ...`}
          value={orderText}
          onChange={e => onOrderTextChange(e.target.value)}
          spellCheck={false}
        />

        <div className="mt-4 sm:mt-6 flex flex-col sm:flex-row gap-3 sm:gap-4">
          <button
            onClick={onParse}
            disabled={loading || !orderText.trim()}
            className={`w-full py-4 sm:py-3.5 px-6 sm:px-8 rounded-xl sm:rounded-2xl font-semibold text-white transition-all duration-200 shadow-md flex items-center justify-center gap-2 text-base sm:text-lg ${
              loading || !orderText.trim()
                ? 'bg-gray-400 cursor-not-allowed'
                : 'bg-[#006B82] hover:bg-[#005A6E] active:scale-[0.98]'
            }`}
          >
            {loading ? (
              <>
                <Loader2 className="w-5 h-5 animate-spin" />
                Parsing...
              </>
            ) : (
              <>
                <Sparkles className="w-5 h-5" />
                Parse Order
              </>
            )}
          </button>

          <button
            onClick={onClear}
            className="w-full sm:w-auto py-4 sm:py-3.5 px-6 sm:px-8 rounded-xl sm:rounded-2xl font-medium border-2 border-gray-200 text-gray-700 hover:border-gray-300 hover:bg-gray-50 transition-colors text-base"
          >
            Clear
          </button>
        </div>

        {error && (
          <div className="mt-4 sm:mt-5 p-4 bg-red-50 border border-red-200 text-red-800 rounded-xl text-sm">
            {error}
          </div>
        )}
      </div>
    </section>
  );
};

// import React from 'react';
// import { Loader2, Sparkles, ScanLine } from 'lucide-react';

// interface OrderInputProps {
//     orderText: string;
//     onOrderTextChange: (text: string) => void;
//     onParse: () => void;
//     onClear: () => void;
//     loading: boolean;
//     error: string | null;
// }

// export const OrderInput: React.FC<OrderInputProps> = ({
//     orderText,
//     onOrderTextChange,
//     onParse,
//     onClear,
//     loading,
//     error,
// }) => {
//     return (
//         <section className="flex flex-col bg-white rounded-2xl shadow-xl border border-gray-200/70 overflow-hidden h-full">
//             <div className="p-4 sm:p-6 border-b border-gray-100 bg-gray-50/70">
//                 <h2 className="text-lg sm:text-xl font-semibold text-gray-900 flex items-center gap-2">
//                     <ScanLine className="w-5 h-5 text-indigo-600" />
//                     Paste Order Text
//                 </h2>
//                 <p className="mt-1 text-sm text-gray-600 hidden sm:block">
//                     Copy-paste the full message here
//                 </p>
//             </div>

//             <div className="flex-1 p-4 sm:p-6 flex flex-col min-h-0">
//                 <textarea
//                     className="flex-1 min-h-[200px] sm:min-h-[300px] p-4 sm:p-5 border-2 border-gray-200 rounded-xl sm:rounded-2xl font-mono text-base leading-relaxed resize-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-shadow shadow-inner bg-gray-50"
//                     placeholder={`Paste your order here...

// Examples:
// • Tomatoes 80 lb
// • Cucumbers – 60 lb
// • Lemons ½ cs
// • 3 Beets
// • 10 ps manzanas 🍎

// ... paste full message ...`}
//                     value={orderText}
//                     onChange={(e) => onOrderTextChange(e.target.value)}
//                     spellCheck={false}
//                 />

//                 <div className="mt-4 sm:mt-6 flex flex-col sm:flex-row gap-3 sm:gap-4">
//                     <button
//                         onClick={onParse}
//                         disabled={loading || !orderText.trim()}
//                         className={`w-full py-4 sm:py-3.5 px-6 sm:px-8 rounded-xl sm:rounded-2xl font-semibold text-white transition-all duration-200 shadow-md flex items-center justify-center gap-2 text-base sm:text-lg ${loading || !orderText.trim()
//                             ? 'bg-gray-400 cursor-not-allowed'
//                             : 'bg-[#006B82] hover:bg-[#005A6E] active:scale-[0.98]'
//                             }`}
//                     >
//                         {loading ? (
//                             <>
//                                 <Loader2 className="w-5 h-5 animate-spin" />
//                                 Parsing...
//                             </>
//                         ) : (
//                             <>
//                                 <Sparkles className="w-5 h-5" />
//                                 Parse Order
//                             </>
//                         )}
//                     </button>

//                     <button
//                         onClick={onClear}
//                         className="w-full sm:w-auto py-4 sm:py-3.5 px-6 sm:px-8 rounded-xl sm:rounded-2xl font-medium border-2 border-gray-200 hover:border-gray-300 hover:bg-gray-50 transition-colors text-base"
//                     >
//                         Clear
//                     </button>
//                 </div>

//                 {error && (
//                     <div className="mt-4 sm:mt-5 p-4 bg-red-50 border border-red-200 text-red-800 rounded-xl text-sm">
//                         {error}
//                     </div>
//                 )}
//             </div>
//         </section>
//     );
// };
